import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ExamAttemptStore extends LocalModel {
    constructor() {
        super('examAttempt', {
            namePlural: 'examAttempts',
            namePluralReal: 'examattempts',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: { url: '/api/examattempts/', params: { limit: 100, sort: '-createdDate' } },
                load: { url: '/api/examattempts/', params: {} },
                save: { url: '/api/examattempts/', params: {} },
                delete: { url: '/api/examattempts/', params: {} },
            },
        });
    }

    @observable total = 0;
    @observable limit = 100;
    @observable offset = 0;
    @observable newExamAttempt = {};
    @observable examAttempt = {};
    @observable examAttempts = [];

    @action
    async submitExam(examId, answers) {
        const response = await util.fetchApi('/api/examattempts/', { method: 'POST' }, {
            exam: examId,
            answers,
        });
        if (response?.status === 201 && response.data?.examAttempt) {
            this.updateKeyValue('examAttempt', response.data.examAttempt);
        }
        return response;
    }

    @action
    async approveAttempt(attemptId, approvalStatus, approvalNote) {
        const response = await util.fetchApi(`/api/examattempts/${attemptId}`, { method: 'PATCH' }, {
            approvalStatus,
            approvalNote,
        });
        return response;
    }

    /**
     * Sign the club's «Kursdiplom» for a passed attempt. The backend creates and
     * approves a coursediploma signing request with the signer's profile images;
     * a missing image comes back as status 400 with `missing`.
     */
    @action
    async signDiploma(attemptId) {
        return util.fetchApi(`/api/examattempts/${attemptId}/sign-diploma`, { method: 'POST' }, {});
    }

    /** Download link for a signed diploma (attempt.diploma = formSigningRequest.id). */
    diplomaDownloadUrl(attempt) {
        if (!attempt || !(attempt.diploma > 0)) {
            return '';
        }
        return `${util.getApiServer()}/api/formsigningrequests/${attempt.diploma}/download?jwtToken=${util.getJwtToken()}`;
    }

    @action
    async loadAttempts(examId) {
        const response = await util.fetchApi('/api/examattempts/', { method: 'GET' }, {
            exam: examId,
            addData: 'users',
            limit: 1000,
        });
        if (response?.status === 200) {
            this.updateKeyValue('examAttempts', response.data || []);
            this.updateKeyValue('total', response.total || 0);
        }
        return response;
    }

    @action
    async loadMyAttempts() {
        const response = await util.fetchApi('/api/examattempts/', { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('examAttempts', response.data || []);
            this.updateKeyValue('total', response.total || 0);
        }
        return response;
    }
}

const store = new ExamAttemptStore();
export default store;
